/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {NetworkPageComponent} from './network-page.component';


export function networkStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.adm.network', {
          url: '/network',
          views: {
            'content@app': {
              component: NetworkPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Network",
            app: ['ADVERTISING', 'DATA']
          }
        });
  return states.build();
}